var map = {
	"./ego": [
		187,
		187
	],
	"./ego.js": [
		187,
		187
	],
	"./kids": [
		732,
		732
	],
	"./kids.js": [
		732,
		732
	],
	"./life": [
		363,
		363
	],
	"./life.js": [
		363,
		363
	],
	"./money": [
		991,
		991
	],
	"./money.js": [
		991,
		991
	],
	"./parents": [
		746,
		746
	],
	"./parents.js": [
		746,
		746
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 687;
module.exports = webpackAsyncContext;